import axios from 'axios';
import { config } from '../config/environment';

export interface ScottishCouncil {
  id: number;
  name: string;
}

export interface ScottishSchool {
  id: number;
  name: string;
  schoolType: string | null;
}

export interface ScottishSchoolWithCouncil extends ScottishSchool {
  councilId: number;
  councilName: string;
}

const base = () => config.scottishCurriculumApiUrl.replace(/\/$/, '');

const toArray = <T>(data: unknown): T[] => {
  if (Array.isArray(data)) return data as T[];
  if (data && typeof data === 'object' && Array.isArray((data as Record<string, unknown>).data))
    return (data as Record<string, unknown>).data as T[];
  return [];
};

export const scottishSchoolService = {
  getCouncils: async (): Promise<ScottishCouncil[]> => {
    const { data } = await axios.get(`${base()}/api/scottish-curriculum/councils`);
    return toArray<ScottishCouncil>(data);
  },

  getSchools: async (councilId: number, schoolType?: string): Promise<ScottishSchool[]> => {
    const params = new URLSearchParams({ councilId: String(councilId) });
    if (schoolType) params.set('schoolType', schoolType);
    const { data } = await axios.get(`${base()}/api/scottish-curriculum/schools?${params}`);
    return toArray<ScottishSchool>(data);
  },

  getAllSchools: async (schoolType: string): Promise<ScottishSchoolWithCouncil[]> => {
    const { data } = await axios.get(
      `${base()}/api/scottish-curriculum/schools/all`,
      { params: { schoolType } }
    );
    return toArray<ScottishSchoolWithCouncil>(data);
  },
};
